import api from "@/api/api-v2-config";

export async function getLeaveBalanceEmployeeAxios() {    
    return await api.get("hrms/leavebalance/employee");
}

export async function getLeaveBalanceSubordinatesAxios() {    
    return await api.get("hrms/leavebalance/subordinates");
}